import { useMemo } from 'react';
import { useOwnerService } from '../contexts/OwnerServiceContext';
import { usePrototype } from '../contexts/PrototypeContext';
import { ownerImages, ownerVehicles } from '../data/ownerProfile';
import type { OwnerVehicle } from '../data/ownerProfile';
import { images } from '../data/images';
import type { OwnerApplication } from '../types/owner';

export interface MyVehicle {
  vehicle: OwnerVehicle;
  app: OwnerApplication;
  driverIds: string[];
}

export function useMyVehicles(): MyVehicle[] {
  const { myApplications } = useOwnerService();
  const { cngList } = usePrototype();
  return useMemo(() => {
    const latest = new Map<string, OwnerApplication>();
    myApplications.forEach((a) => {
      const key = a.vehicleId ?? a.id;
      const prev = latest.get(key);
      if (!prev || prev.status === 'বাতিল' || (a.status !== 'বাতিল' && a.stage > prev.stage)) latest.set(key, a);
    });
    return Array.from(latest.entries())
      .map(([key, app]) => {
        const known = ownerVehicles.find((v) => v.id === key);
        const vehicle: OwnerVehicle = known ?? {
          id: key,
          type: app.vehicleType,
          typeLabel: app.vehicleType === 'cng' ? 'সিএনজি' : 'মোটরসাইকেল',
          reg: app.vehicleReg,
          brand: app.model.split(' ')[0],
          model: app.model.split(' ').slice(1).join(' '),
          color: '—',
          year: '—',
          chassis: app.chassis,
          engine: app.engine,
          fuel: app.vehicleType === 'cng' ? 'CNG' : 'পেট্রোল',
          regDate: '—',
          ownership: 'একক মালিকানা',
          qrId: 'ডিএমপি অনুমোদনের পর তৈরি হবে',
          image: app.vehicleType === 'cng' ? images.cng : ownerImages.motorcycle,
          appId: app.id,
          division: 'ট্রাফিক-মিরপুর'
        };
        const driverIds = cngList.find((c) => c.id === key)?.driverIds ?? [];
        return { vehicle, app, driverIds };
      });
  }, [myApplications, cngList]);
}

export function useMyVehicle(id: string): MyVehicle | undefined {
  const list = useMyVehicles();
  return list.find((v) => v.vehicle.id === id) ?? list[0];
}
